module.exports = __webpack_public_path__ + "static/img/12areaB_11.174fd03.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_11.png
// module id = 1103
// module chunks = 1